/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-27T11:47:12-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-03-28T12:07:44-07:00
*/



import React, { Component } from 'react';
import moment from 'moment';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions, type, spacing, textColor } from '../../../style';
import * as common from '../../../common';

const style = StyleSheet.create({
  title: {
      ...type.XL,
      ...spacing.MARGIN_BOTTOM_SM
  },
  meta: {
    ...type.MD,
    ...textColor.NORMAL
  },
  timeStamp: {
    ...textColor.NORMAL
  }
})

class UserDetails extends Component {

  lastLoggedIn(timestamp,location) {
    if(timestamp === null) {
      // last activity is hidden
      return (<span></span>);
    } else {
      return `${common.tsSince(timestamp.date)} from ${location}`;
    }
  }

  render() {
    let profile = this.props.profile;
    return (
      <div>
        <h1 className={css(style.title)}>{this.props.username}</h1>
        <div className={css(style.meta)}>{profile.age} · {profile.city}, {profile.region}, {profile.country} </div>
        <div className={css(style.timeStamp)}>
          {profile.last_activity_dt ? this.lastLoggedIn(profile.last_activity_dt,profile.last_login_location) : ''}
        </div>
      </div>
    );
  }
}

export default UserDetails;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/UserDetails.jsx